import { Pipe, PipeTransform } from '@angular/core';
import { getIconPath, IconType } from './icons';

@Pipe({
    name: 'iconPath',
})
export class IconPathPipe implements PipeTransform {
    public transform(type: IconType): string {
        return getIconPath(type);
    }
}